import { Dropdown, Menu } from "antd";
import { Button } from "components/common";
import { useGetTemplateHistoryQuery } from "features/script/api";
import { useCallback } from "react";
import { useParams } from "react-router-dom";

const VersionHistoryDropDown = () => {
  const params = useParams();

  const {
    data: templateHistory,
    isLoading: historyLoading,
    error: historyError,
    refetch,
  } = useGetTemplateHistoryQuery(
    {
      page_name: params?.id,
    },
    { skip: !params?.id }
  );

  const updateVersion = (newVersion) => {
    const url = new URL(window.location.href);
    url.searchParams.set("version", newVersion);
    window.open(url);
  };

  const convertDate = (timestamp) => {
    const date = new Date(timestamp);
    const options = { month: "long", day: "2-digit", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const renderVersionHistory = useCallback(() => {
    if (!templateHistory || templateHistory.length === 0) {
      return (
        <Menu>
          <Menu.Item disabled>No version found</Menu.Item>
        </Menu>
      );
    }

    return (
      <Menu>
        {templateHistory.map((it, index) => (
          <Menu.ItemGroup key={index} title={it.label}>
            {it?.options?.map((version, key) => (
              <Menu.Item key={index + key + 1}>
                <div onClick={() => updateVersion(version?.version)}>
                  <div
                    style={{
                      color: "black",
                      fontWeight: "bolder",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                    key={index + key + "child"}
                  >
                    {version.updatedByData
                      ? version.updatedByData?.username
                      : "-"}
                  </div>
                  <div style={{ color: "#A7A7A7", fontSize: "12px" }}>
                    <span style={{ color: "#707070", fontSize: "12px" }}>
                      {convertDate(version.updated_at)}
                    </span>
                  </div>{" "}
                </div>
              </Menu.Item>
            ))}
          </Menu.ItemGroup>
        ))}
      </Menu>
    );
  }, [templateHistory]);
  return (
    <Dropdown overlay={renderVersionHistory()} trigger="hover" suffixIcon="">
      <Button
        text="Version History"
        type="light"
        color="#1677FF"
        style={{
          backgroundColor: "#f0f8ff",
          borderColor: "#d6e4ff",
          color: "#1677FF",
          height: 48,
          fontWeight: 700,
        }}
      />
    </Dropdown>
  );
};

export default VersionHistoryDropDown;
